import flatten from 'lodash/flatten';

export const periods = [
    '2026-03-02',
    '2026-03-09',
    '2026-03-16',
    '2026-03-23',
];

export const enabledDishes = {
    women: [
        '5284',
        '5286',
        '5287',
        '4344',
        '4011',
        '3941',
        '3945',
        '3942',
    ],
    guest: [
        '3838',
        '4698',
        '58',
        '3723',
        '3843',
        '4102',
        '5312',
    ],
};

export const availableBasketDishIds = flatten(Object.values(enabledDishes));
